import React from "react";
import { Route } from "react-router-dom";
import UserRegisterTest from "../mobile/dev/UserRegisterTest";

console.log("process.env.NODE_ENV", process.env.NODE_ENV);
const devRoutes =
  process.env.NODE_ENV === "development"
    ? {
        // key="user-register"
        path: "/dev",
        // element={<UserRegisterTest />}
        children: [
          {
            // index: true,
            path: "user-register",
            element: <UserRegisterTest />,
          },
        ],
      }
    : {};

export default devRoutes;
